import { omitBy as _omitBy } from 'lodash'

export const MESSAGE = 'MESSAGE'
export const MESSAGE_RESET = 'MESSAGE_RESET'

export const message = (text, status, statusKey, delay, closeCallback, align) => ({
    type: MESSAGE,
    text,
    status,
    statusKey,
    delay,
    closeCallback,
    align,
})
export const messageReset = () => ({ type: MESSAGE_RESET })

export const getMessage = state => state

const filterAction = obj => _omitBy(obj, (val, prop) => prop === 'type' || val === undefined)

const defaults = {
    status: '',
    statusKey: '',
    text: '',
    delay: 5000,
}

export default (message = { ...defaults }, action = {}) => {
    switch (action.type) {
        case MESSAGE:
            return { ...message, ...filterAction(action) }
        case MESSAGE_RESET:
            return defaults
        default:
            return message
    }
}
